import { getDefaultStore } from "jotai";
import { createSearchParams } from "react-router-dom";

import { setAuthHeader } from "./axios";

import { isAuthenticatedAtom, tokenAtom } from "@/store";

/**
 *
 * Sets or clears the session by updating the axios header.
 * Note: Token storage is now handled by atomWithStorage in the store.
 * @param token The JWT token, or null to clear the session.
 */
export const setSession = (token: string | null): void => {
  if (token) {
    setAuthHeader(token); // Update axios header
  } else {
    setAuthHeader(null); // Clear axios header
  }
};

/**
 * Clear all auth-related state and redirect to /login with ?redirect=
 */
export const logoutAndRedirect = (): void => {
  const store = getDefaultStore();

  try {
    // Clear jotai atoms stored in localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("isAuthenticated");

    // Clear axios header
    setSession(null);

    // Reset atoms (best-effort; wrapped to avoid runtime errors if provider not mounted)
    try {
      store.set(isAuthenticatedAtom, false);
      store.set(tokenAtom, null);
    } catch {
      // ignore
    }
  } finally {
    const currentPath = window.location.pathname + window.location.search;

    // Avoid stacking redirects if already on login page (guest guard)
    if (window.location.pathname === "/login") {
      return;
    }
    const params = createSearchParams({ redirect: currentPath }).toString();
    const target = `/login?${params}`;

    if (window.location.pathname + window.location.search !== target) {
      window.location.href = target;
    }
  }
};
